import { animate, query, style, transition, trigger } from '@angular/animations';

/**
 * Simple fade animation for route transitions.
 */
export const routeFadeAnimation = trigger('routeFade', [
	transition('* => *', [
		query(':enter', [style({ opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%' })], {
			optional: true
		}),
		query(
			':leave',
			[
				style({ opacity: 1 }),
				animate(
					'200ms ease-in-out',
					style({ opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%' })
				)
			],
			{ optional: true }
		),
		query(
			':enter',
			[style({ opacity: 0 }), animate('200ms ease-in-out', style({ opacity: 1, position: 'relative' }))],
			{ optional: true }
		)
	])
]);
